import { render, staticRenderFns } from "./PopupPanel.vue?vue&type=template&id=e065e0b4"
import script from "./PopupPanel.vue?vue&type=script&lang=ts"
export * from "./PopupPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports